import { TriangleAlert } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/shadcn/tooltip';

interface LabsTabLabelProps {
  hasInsurance: boolean;
}

export function LabsTabLabel({ hasInsurance }: LabsTabLabelProps) {
  if (hasInsurance) {
    return <>Labs</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center gap-1">
          Labs
          <TriangleAlert className="size-3 text-amber-500" aria-label="Missing insurance" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-56 text-xs">
        No insurance info — labs may not be submittable
      </TooltipContent>
    </Tooltip>
  );
}
